import React, { useMemo } from "react";
import { Tooltip } from "@mui/material";
import { BsThreeDotsVertical } from "react-icons/bs";
// Components
import APopover from "views/pages/manage/common/a-popover";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";


// Constants
import { REACT_ICONS_STYLE } from "views/pages/manage/edpOps/constant/batch-search";
import DepositedListAction from "../../../cheque-management/deposites/components/DepositedListAction";

const DepositedActionMenu = ({ row,getChequeDateExtensionLogs  }) => {
  const menuItems = useMemo(
    () => [
      {
        text: "View Logs",
        isDisabled: (rowData) => false,
        handleClick: async (rowData) => {
            getChequeDateExtensionLogs(rowData);
        },
      },
    ],
    []
  );

  return (
    <APopover
      buttonComponent={(onClick) => (
        <Tooltip title="More Actions">
          <span onClick={onClick}>
            <IconButtonWrapper>
              <BsThreeDotsVertical style={REACT_ICONS_STYLE} />
            </IconButtonWrapper>
          </span>
        </Tooltip>
      )}
      menuComponent={(closeForm) => (
        <DepositedListAction
          handleClose={closeForm}
          menuItems={menuItems}
          rowData={row}
        />
      )}
      sx={{
        "& .MuiPaper-root": {
          border: `1px solid #E2E2E2`,
          boxShadow: "0px 3px 4px 0px #00000014 !important",
          borderRadius: "8px",
        },
      }}
    />
  );
};

export default React.memo(DepositedActionMenu);
